import ROUTE_NAMES from '../../router/names';
import decorate from './decorate';
import MIDDLE from "../../router/admin/middle/names";

export default (notice, editable) => {
    return decorate([
        {
            title: '个人信息',
            icon: '&#xe60a;',
            active: true,
            children: [
                {
                    title: '信息编辑',
                    route_name: ROUTE_NAMES.ADMIN.PERSONAL.INFORMATION
                },
                {
                    title: '站内通知',
                    route_name: ROUTE_NAMES.ADMIN.PERSONAL.INTERNAL_MESSAGE_UNREAD,
                    related_route_names: [
                        ROUTE_NAMES.ADMIN.PERSONAL.INTERNAL_MESSAGE_UNREAD,
                        ROUTE_NAMES.ADMIN.PERSONAL.INTERNAL_MESSAGE_READ
                    ],
                    notice: notice === true
                }
            ]
        },
        {
            title: '用户相关',
            icon: '&#xe62b;',
            active: true,
            children: [
                {
                    title: '用户管理',
                    route_name: ROUTE_NAMES.ADMIN.USER.MANAGE,
                    permission: editable === true
                },
                {
                    title: '用户概览',
                    route_name: ROUTE_NAMES.ADMIN.USER.OVERVIEW
                }
            ]
        },
        {
            title: '赛事相关',
            icon: '&#xe633;',
            active: true,
            children: [
                {
                    title: '基本信息管理',
                    route_name: ROUTE_NAMES.ADMIN.COMPETITION.MANAGE,
                    permission: editable === true
                },
                {
                    title: '参赛审批',
                    route_name: ROUTE_NAMES.ADMIN.COMPETITION.PLAYER_APPLICATION_UNFINISHED,
                    related_route_names: [
                        ROUTE_NAMES.ADMIN.COMPETITION.PLAYER_APPLICATION_FINISHED,
                        ROUTE_NAMES.ADMIN.COMPETITION.PLAYER_APPLICATION_UNFINISHED
                    ],
                    permission: editable === true
                },
                {
                    title: '资料上传',
                    route_name: ROUTE_NAMES.ADMIN.MIDDLE.MIDDLECHECK_OVERVIEW,
                    related_route_names: [
                        ROUTE_NAMES.ADMIN.MIDDLE.MIDDLECHECK_OVERVIEW,
                    ]
                },
                {
                    title: '填报结果',
                    route_name: ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_OVERVIEW,
                    related_route_names: [
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_OVERVIEW,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_CONTACT,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_CERTIFICATE,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_FORECAST_ATTENDANCE,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_NARRATE,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_REFEREE,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_FLAG_BEARER,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_INTRODUCE,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_FUNDING,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_SPONSORSHIP,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_ROBOT,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_CONSIGNEE,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_PRESENT,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_PROPAGANDISTS,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_TAOBAO,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_ACCOMMODATION,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_GROUP_PHOTO,
                        ROUTE_NAMES.ADMIN.PLAYER.INFORMATION_SPECIAL_COMPETITION
                    ]
                },
                {
                    title: '单项赛管理',
                    route_name: ROUTE_NAMES.ADMIN.COMPETITION.SPECIAL
                },
                {
                    title: '主赛事晋级',
                    route_name: ROUTE_NAMES.ADMIN.COMPETITION.PROMOTION,
                    permission: editable === true
                },
                {
                    title: '比赛结果管理',
                    route_name: ROUTE_NAMES.ADMIN.COMPETITION.AWARD_CHAMPION,
                    related_route_names: [
                        ROUTE_NAMES.ADMIN.COMPETITION.AWARD_CHAMPION,
                        ROUTE_NAMES.ADMIN.COMPETITION.AWARD_TRADITIONAL,
                        ROUTE_NAMES.ADMIN.COMPETITION.AWARD_SPECIAL_PLAYER,
                        ROUTE_NAMES.ADMIN.COMPETITION.AWARD_SPECIAL_MEMBER
                    ],
                    permission: editable === true
                },
                {
                    title: '证书模板管理',
                    route_name: ROUTE_NAMES.ADMIN.COMPETITION.CERTIFICATE_TEMPLATE,
                    permission: editable === true
                }
            ]
        },
        {
            title: '学校相关',
            icon: '&#xe607;',
            active: true,
            children: [
                {
                    title: '学校管理',
                    route_name: ROUTE_NAMES.ADMIN.SCHOOL.MANAGE,
                    permission: editable === true
                },
                {
                    title: '学校概览',
                    route_name: ROUTE_NAMES.ADMIN.SCHOOL.OVERVIEW
                }
            ]
        },
        {
            title: '队伍相关',
            icon: '&#xe608;',
            active: true,
            children: [
                {
                    title: '队伍管理',
                    route_name: ROUTE_NAMES.ADMIN.TEAM.MANAGE,
                    permission: editable === true
                },
                {
                    title: '队伍概览',
                    route_name: ROUTE_NAMES.ADMIN.TEAM.OVERVIEW
                }
            ]
        }
    ]);
};
